<template>
  <v-layout class="grey lighten-4" column>
    <div class="noto bold primary--text pa-3 d-md-flex align-center" width="100%">
      <div class="title primery--text">Datos del perfil</div>
    </div>

    <v-flex xs12>
      <v-row justify="center">
        <v-col md="4">
          <v-row>
            <v-col cols="12">
              <v-card flat tile>
                <v-card-title>
                  <v-row justify="center">
                    <v-col>
                      Información básica del perfil
                    </v-col>
                    <v-col class="d-flex justify-end">
                      <v-btn
                        rounded
                        small
                        depressed
                        color="primary"
                        :disabled="!form.isValid"
                        @click="submit">
                        Guardar datos de perfil
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text>
                  <v-form ref="form" v-model="form.isValid">
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          label="Nombres"
                          v-model="form.data.firstName"
                          :rules="form.rules.firstName"
                          required
                        />
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          label="Apellidos"
                          v-model="form.data.lastName"
                          :rules="form.rules.lastName"
                          required
                        />
                      </v-col>

                      <v-col cols="12">
                        <v-text-field
                          label="Correo electrónico"
                          v-model="form.data.email"
                          :rules="form.rules.email"
                          disabled
                          required
                        />
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          label="Teléfono"
                          v-model="form.data.phone"
                          :rules="form.rules.phone"
                          maxlength="10"
                          required
                        />
                        </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-flex>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

  </v-layout>
</template>

<script>
export default {
  name: 'Profile user',
  data () {
    return {
      overlay: false,
      form: {
        isValid: false,
        data: {
          firstName: null,
          lastName: null,
          email: null,
          phone: null
        },
        rules: {
          firstName: [
            v => !!v || this.$t('validations.firstName'),
            v => /^[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ ]*$/.test(v) || this.$t('validations.alphaNumericAcentuated')
          ],
          lastName: [
            v => !!v || this.$t('validations.lastName'),
            v => /^[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ ]*$/.test(v) || this.$t('validations.alphaNumericAcentuated')
          ],
          phone: [
            v => !!v || 'Phone is required',
            v => /[0-9]/.test(v) || 'Enter a valid number',
            v => v.length === 10 || 'Phone must be a 10 digits long'
          ]
        }
      }
    }
  },
  mounted () {
    this.form.data.firstName = this.$store.state.login.user.firstName
    this.form.data.lastName = this.$store.state.login.user.lastName
    this.form.data.email = this.$store.state.login.user.email
    this.form.data.phone = this.$store.state.login.user.phone
  },
  computed: {
    userId () {
      return this.$store.state.login.user._id
    }
  },
  methods: {
    async submit () {
      this.overlay = true
      try {
        const response = await this.$api.put(`/v1/users/${this.userId}`, this.form.data)
        const payload = response
        payload.uuid = this.userId
        this.$store.commit('login/user/set', payload)
        this.$toasted.show('Se ha actualizado correctamente la información de usuario.', { duration: 3500, type: 'success', position: 'top-center', iconPack: 'mdi', icon: 'mdi-check-circle' })
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    }
  }
}
</script>
